import { ref, watch, onMounted, onActivated } from 'vue'
import type { IndexEchart, BarChartData } from '@/types/index'
import { chanceSaleList, userList, sourceList } from '@/api/gucangSales/index'

export default function barEChartData(formState: BarChartData) {
  const principalStatistics = ref<IndexEchart.BarData>()
  const businessAmount = ref<IndexEchart.BarData>()
  const cueSourceStatistics = ref<IndexEchart.BarData>()

  const getSaleData = async () => {
    try {
      const res = await chanceSaleList({
        ...formState.chanceSales
      })

      const xAxisD = getXaxis(res.data, 'countTime')
      const yAxisD = getYaxis(res.data, 'salesAmount')
      businessAmount.value = {
        legendArr: ['商机金额(万元)'],
        xAxisData: xAxisD,
        seriesArr: [
          {
            name: '商机金额(万元)',
            type: 'bar',
            itemStyle: {
              color: '#3F97FF'
            },
            data: yAxisD
          }
        ]
      }
      // console.log('xAxisD: ', xAxisD)
    } catch (error) {
      businessAmount.value = {
        legendArr: ['商机金额(万元)'],
        xAxisData: [],
        seriesArr: [
          {
            name: '商机金额(万元)',
            type: 'bar',
            itemStyle: {
              color: '#3F97FF'
            },
            data: []
          }
        ]
      }
      console.log('getSaleDataerror: ', error)
    }
  }
  watch(
    () => formState.chanceSales,
    () => {
      getSaleData()
    },
    { deep: true, immediate: true }
  )
  const getUserata = async () => {
    try {
      const res = await userList({
        ...formState.userList
      })
      const xAxisCustomer = getXaxis(res.data, 'userName')
      const yAxisDCustomer = getYaxis(res.data, 'customerCount')
      const yAxisDClue = getYaxis(res.data, 'clueCount')
      const yAxisDChance = getYaxis(res.data, 'chanceCount')
      const yAxisDFollow = getYaxis(res.data, 'followCount')

      principalStatistics.value = {

        legendArr: ['客户', '线索', '商机', '跟进数'],
        xAxisData: xAxisCustomer,

        seriesArr: [
          {
            name: '客户',
            type: 'bar',
            itemStyle: {
              color: '#3F97FF'
            },
            data: yAxisDCustomer
          },
          {
            name: '线索',
            type: 'bar',
            itemStyle: {
              color: '#877CED'
            },
            data: yAxisDClue
          },
          {
            name: '商机',
            type: 'bar',
            itemStyle: {
              color: '#36C8E1'
            },
            data: yAxisDChance
          },
          {
            name: '跟进数',
            type: 'bar',
            itemStyle: {
              color: '#FFB648'
            },
            data: yAxisDFollow
          }
        ]
      }
    } catch (error) {
      principalStatistics.value = {
        legendArr: ['客户', '线索', '商机', '跟进数'],
        xAxisData: [],
        seriesArr: [
          {
            name: '客户',
            type: 'bar',
            itemStyle: {
              color: '#3F97FF'
            },
            data: []
          }
        ]
      }
      console.log('getSaleDataerror: ', error)
    }
  }
  watch(
    () => formState.userList,
    () => {
      getUserata()
    },
    { deep: true, immediate: true }
  )
  const getCuledata = async () => {
    try {
      const res = await sourceList({
        ...formState.clueData
      })
      const xAxisCustomer = getXaxis(res.data, 'source')
      const yAxisDCustomer = getYaxis(res.data, 'customerCount')
      const yAxisDClue = getYaxis(res.data, 'clueCount')
      const yAxisDChance = getYaxis(res.data, 'chanceCount')
      const yAxisDFollow = getYaxis(res.data, 'followCount')

      cueSourceStatistics.value = {

        legendArr: ['客户', '线索', '商机', '跟进数'],
        xAxisData: xAxisCustomer,
        seriesArr: [
          {
            name: '客户',
            type: 'bar',
            itemStyle: {
              color: '#3F97FF'
            },
            data: yAxisDCustomer
          },
          {
            name: '线索',
            type: 'bar',
            itemStyle: {
              color: '#877CED'
            },
            data: yAxisDClue
          },
          {
            name: '商机',
            type: 'bar',
            itemStyle: {
              color: '#36C8E1'
            },
            data: yAxisDChance
          },
          {
            name: '跟进数',
            type: 'bar',
            itemStyle: {
              color: '#FFB648'
            },
            data: yAxisDFollow
          }
        ]
      }
    } catch (error) {
      cueSourceStatistics.value = {
        legendArr: ['客户'],
        xAxisData: [],
        seriesArr: [
          {
            name: '客户',
            type: 'bar',
            itemStyle: {
              color: '#3F97FF'
            },
            data: []
          }
        ]
      }
      console.log('getSaleDataerror: ', error)
    }
  }
  watch(
    () => formState.clueData,
    () => {
      getCuledata()
    },
    { deep: true, immediate: true }
  )
  onActivated(() => {
    getCuledata()
    getSaleData()
    getUserata()
  })
  onMounted(() => {
    // getSaleData()
  })
  return { principalStatistics, businessAmount, cueSourceStatistics }
}
function getXaxis(data: any, valueName: string) {
  const arr: string[] = []
  if (data.length > 0) {
    data.forEach((item: any) => {
      arr.push(item[valueName] as never)
    })
  } else {
    return []
  }

  return arr
}
function getYaxis(data: any, valueName: string) {
  const arr: number[] = []
  if (data.length > 0) {
    data.forEach((item: any) => {
      arr.push(item[valueName] as never)
    })
  } else {
    return []
  }

  return arr
}
